// Globale Variable für Kunden-Tags (muss in theme.liquid gesetzt werden!)
window.customerTags = window.customerTags || [];

// Produkte mit gesperrter Mengenauswahl (8001734050058 = VIP)
window.qtyLockedProductIds = [8001734050058, 9916405842186];

const CustomCartDrawer = {
  // DOM-Elemente
  nodes: {
    drawer: null,
    drawerInner: null,
    content: null,
    itemsContainer: null,
    itemTemplate: null,
    subtotal: null,
    shippingNotice: null,
    checkoutButton: null,
    vipModule: null,
    vipSelector: null,
    vipAddButton: null,
    vipPotentialSavings: null,
    vipSavingsAmount: null,
    loadingOverlay: null,
    successMessage: null,
  },
  
  // Status & State-Management
  isLoading: false,
  isVip: false,
  lastFocusedElement: null,
  state: {
    lastAction: null,
    itemCount: 0
  },

  // 🚀 NEU: Template Cache
  templateCache: {
    compiled: null,
    originalHtml: null
  },

  // Konfiguration
  settings: {
    freeShippingThreshold: 4900,
    vipTag: 'VIP25',
    routes: {
      cartUrl: window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js',
      cartAddUrl: window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js',
      cartChangeUrl: window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js',
      cartUpdateUrl: window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js',
    },
    
    // SICHERER Money-Formatter
    formatMoney: function(cents, format = null) {
      if (typeof cents === 'string') {
        cents = parseInt(cents.replace(/[^0-9]/g, ''), 10) || 0;
      }
      const moneyFormat = format || Shopify.money_format || '€{{amount}}';
      const currency = Shopify.currency?.active || 'EUR';
      try {
        const amount = (cents / 100).toFixed(2);
        return moneyFormat
          .replace('{{amount}}', amount)
          .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
          .replace('$', '€');
      } catch (e) {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency: currency,
          minimumFractionDigits: 2
        }).format(cents / 100);
      }
    },
    
    moneyFormat: Shopify.money_format || '€{{amount}}',

    vipDiscount: parseFloat('{{ settings.vip-discount | default: 25 | divided_by: 100.0 }}'),
  },

/*
      // 🔢 Zentrale Bubble-Update-Funktion mit Retry
  updateCartBubble: function(count, retries) {
    const bubble = document.getElementById('cart-count-bubble');

    if (bubble) {
      // Element ist da → direkt aktualisieren
      if (count > 0) {
        bubble.innerHTML = count;
        bubble.classList.remove('visibility-hidden');
      } else {
        bubble.innerHTML = '0';
        bubble.classList.add('visibility-hidden');
      }
      return;
    }

    // Element (noch) nicht da → ein paar Mal nachversuchen
    const remaining = typeof retries === 'number' ? retries : 10;
    if (remaining <= 0) return;

    clearTimeout(this._bubbleRetryTimeout);
    this._bubbleRetryTimeout = setTimeout(() => {
      this.updateCartBubble(count, remaining - 1);
    }, 200);
  },
*/

  bubble: {
    element: null,
    lastUpdate: 0,
    isOwned: false
  },

  init: function() {
    this.nodes.drawer = document.getElementById('custom-cart-drawer');
    if (!this.nodes.drawer) return;

    this.nodes.drawerInner = this.nodes.drawer.querySelector('.drawer__inner');
    this.nodes.content = this.nodes.drawer.querySelector('.drawer__content');
    this.nodes.itemsContainer = document.getElementById('cart-drawer-items');
    this.nodes.itemTemplate = document.getElementById('cart-drawer-item-template');
    this.nodes.subtotal = document.getElementById('cart-drawer-subtotal');
    this.nodes.shippingNotice = document.getElementById('cart-drawer-shipping-notice');
    this.nodes.checkoutButton = this.nodes.drawer.querySelector('.cart-drawer__checkout-button');
    this.nodes.vipModule = this.nodes.drawer.querySelector('.drawer__footer .drawer__vip-module');
    this.nodes.vipSelector = document.getElementById('vip-variant-selector');
    this.nodes.vipAddButton = document.getElementById('add-vip-button');
    this.nodes.vipPotentialSavings = document.getElementById('vip-potential-savings');
    this.nodes.vipSavingsAmount = this.nodes.drawer.querySelector('.vip-savings-amount');
    this.nodes.loadingOverlay = this.nodes.drawer.querySelector('.drawer__loading-overlay');
    this.nodes.successMessage = document.getElementById('cart-drawer-success-message');

    // Einstellungen lesen
     this.settings.freeShippingThreshold = parseInt(this.nodes.drawer.dataset.freeShippingThreshold || '4900', 10);
    this.settings.vipTag = this.nodes.drawer.dataset.vipTag || 'VIP25';
    this.isVip = window.customerTags.includes(this.settings.vipTag);
    this.state.itemCount = parseInt(this.nodes.drawer.dataset.itemCount || '0', 10);

    // 🎯 SCHRITT 1: Bubble-Kontrolle etablieren (SOFORT)
    this.takeBubbleOwnership();

    // 🎯 SCHRITT 2: Template vorbereiten
    this.prepareTemplate();
    
    // 🎯 SCHRITT 3: Events binden
    this.bindEvents();
    
    // 🎯 SCHRITT 4: Server-Sync (asynchron, non-blocking)
    this.checkCartConsistency();
    
    console.log('Custom Cart Drawer Initialized with Bubble Control');
  },

  // 🎯 NEUE METHODE: Übernimmt Kontrolle über die Bubble
  takeBubbleOwnership: function() {
    // Funktion um Bubble zu finden (mehrere mögliche Selektoren)
    const findBubble = () => {
      return document.getElementById('cart-count-bubble') ||
             document.querySelector('[id*="cart"][id*="count"]') ||
             document.querySelector('.cart-count-bubble') ||
             document.querySelector('[data-cart-count]');
    };

    // Sofortiger Versuch
    let bubble = findBubble();
    
    if (bubble) {
      this.initializeBubble(bubble);
    }

    // MutationObserver NUR für das Header-Element (viel effizienter)
    const header = document.querySelector('header, .header, #shopify-section-header');
    if (header) {
      const observer = new MutationObserver((mutations) => {
        // Nur wenn wir die Bubble noch nicht haben
        if (!this.bubble.isOwned) {
          bubble = findBubble();
          if (bubble) {
            this.initializeBubble(bubble);
            observer.disconnect();
          }
        }
      });
      
      observer.observe(header, { 
        childList: true, 
        subtree: true 
      });
      
      // Auto-disconnect nach 3 Sekunden
      setTimeout(() => observer.disconnect(), 3000);
    }

    // Fallback: window.load Event
    if (!this.bubble.isOwned) {
      window.addEventListener('load', () => {
        setTimeout(() => {
          bubble = findBubble();
          if (bubble) this.initializeBubble(bubble);
        }, 100);
      }, { once: true });
    }
  },

  // 🎯 NEUE METHODE: Initialisiert die Bubble mit Schutz
  initializeBubble: function(element) {
    if (!element || this.bubble.isOwned) return;
    
    this.bubble.element = element;
    this.bubble.isOwned = true;
    
    console.log('✅ Bubble ownership established');
    
    // Sofortiges Update
    this.updateCartBubbleInternal(this.state.itemCount);
    
    // 🔒 SCHUTZ: Verhindere externe Änderungen
    this.protectBubble(element);
  },

  // 🔒 NEUE METHODE: Schützt die Bubble vor externen Updates
  protectBubble: function(element) {
    // MutationObserver der externe Änderungen abfängt
    const protector = new MutationObserver((mutations) => {
      const currentTime = Date.now();
      
      // Wenn Update nicht von uns kam (> 50ms her)
      if (currentTime - this.bubble.lastUpdate > 50) {
        console.log('🛡️ External bubble modification detected - reverting');
        this.updateCartBubbleInternal(this.state.itemCount);
      }
      
    });
    
    protector.observe(element, {
      characterData: true,
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });
    
    // Speichere für später
    this.bubble.protector = protector;
  },

  // 🎯 ÜBERARBEITETE METHODE: Interne Bubble-Update-Logik
  updateCartBubbleInternal: function(count) {
    const bubble = this.bubble.element;
    if (!bubble) return;
    
    // Timestamp setzen BEVOR wir ändern
    this.bubble.lastUpdate = Date.now();
    
    const countStr = String(count);
    
    // Update nur wenn nötig
    if (bubble.textContent !== countStr) {
      bubble.textContent = countStr;
    }
    
    // Visibility
    const shouldHide = count === 0;
    const hasHiddenClass = bubble.classList.contains('visibility-hidden');
    
    if (shouldHide !== hasHiddenClass) {
      bubble.classList.toggle('visibility-hidden', shouldHide);
    }
    
    // Alternative Klassen die Themes verwenden könnten
    if (shouldHide) {
      bubble.classList.remove('is-visible', 'show');
      bubble.classList.add('is-hidden', 'hide');
    } else {
      bubble.classList.remove('is-hidden', 'hide');
      bubble.classList.add('is-visible', 'show');
    }
  },

  // 🎯 VEREINFACHTE PUBLIC METHODE: Update Cart Bubble
  updateCartBubble: function(count) {
    // State aktualisieren
    this.state.itemCount = count;
    
    // Bubble updaten (wenn wir sie haben)
    if (this.bubble.isOwned) {
      this.updateCartBubbleInternal(count);
    } else {
      // Noch keine Bubble - versuche sie zu finden
      this.takeBubbleOwnership();
      // Und nochmal probieren
      if (this.bubble.isOwned) {
        this.updateCartBubbleInternal(count);
      }
    }
  },

/*  
  // 🎯 ÜBERARBEITETE METHODE: Cart Consistency Check
  checkCartConsistency: function() {
    fetch(this.settings.routes.cartUrl)
      .then(response => response.json())
      .then(cart => {
        if (cart.item_count !== this.state.itemCount) {
          console.log(`🔄 Cart sync: Local=${this.state.itemCount}, Server=${cart.item_count}`);
          this.updateCartBubble(cart.item_count);
          
          if(cart.item_count > 0) {
             this.setVipModuleVisibility(!this.cartHasVip(cart), cart.item_count);
          }
        }
      })
      .catch(e => console.warn('Cart consistency check failed', e));
  },
*/

  // 🎯 ÜBERARBEITETE METHODE: Cart Consistency Check
  checkCartConsistency: function() {
  fetch(this.settings.routes.cartUrl)
    .then(response => response.json())
    .then(cart => {
      if (cart.item_count !== this.state.itemCount) {
        console.log(`🔄 Cart sync: Local=${this.state.itemCount}, Server=${cart.item_count}`);
        this.updateCartBubble(cart.item_count);
        this.state.itemCount = cart.item_count;
      }

      // VIP-Box immer nachziehen (auch wenn item_count gleich blieb)
      this.setVipModuleVisibility(cart);
    })
    .catch(e => console.warn('Cart consistency check failed', e));
},

  // 🚀 NEU: Template-Vorbereitung
  prepareTemplate: function() {
    if (!this.nodes.itemTemplate) return;
    this.templateCache.originalHtml = this.nodes.itemTemplate.innerHTML;
  },

  bindEvents: function() {
    // Schließen-Buttons
    this.nodes.drawer.querySelectorAll('.drawer__close-button, .drawer__continue-shopping').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    });

    document.body.addEventListener('click', (event) => {
      const openButton = event.target.closest('.open-drawer');

      if (openButton) {
        event.preventDefault(); 
        this.lastFocusedElement = openButton; 
        this.open();
      }
    });

    // Click Outside Listener
    document.addEventListener('click', (event) => {
      if (event.target.closest('.open-drawer')) {
        return;
      }

      const isDrawerVisible = document.body.classList.contains('drawer-open');
      const clickedInsideDrawer = this.nodes.drawerInner?.contains(event.target);
      const clickedOnContinueShopping = event.target.closest('.drawer__continue-shopping');

      if (clickedOnContinueShopping || (isDrawerVisible && !clickedInsideDrawer)) {
        this.close();
      }
    });

    // Event Delegation für "In den Warenkorb"-Formulare
    // → nur noch EIN Request, Theme-Handler werden blockiert
document.body.addEventListener('submit', (event) => {
  const form = event.target.closest('form[data-type="add-to-cart-form"]');
  if (!form) return;

  // Browser-Submit + andere JS-Handler stoppen
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') {
        event.stopImmediatePropagation();
      }

      // Variant-ID ermitteln
      let variantId;
      const variantSelectors = form.querySelector('#variants');
      const productHasVariants = variantSelectors && !variantSelectors.hasAttribute('hidden');

      if (productHasVariants) {
        const checked = form.querySelector('input[name="id"]:checked');
        if (!checked) {
          console.error('Keine Variante ausgewählt.');
          return;
        }
        variantId = checked.value;
      } else {
        const hiddenId = form.querySelector('input[name="id"][type="hidden"]');
        if (!hiddenId) {
          console.error('Keine Variant-ID im Formular gefunden.');
          return;
        }
        variantId = hiddenId.value;
      }

      // Quantity ermitteln
      let quantity = 1;
      const qtyInput = form.querySelector('input[name="quantity"]');
      if (qtyInput) {
        const parsed = parseInt(qtyInput.value, 10);
        if (!isNaN(parsed) && parsed > 0) {
          quantity = parsed;
        }
      }

      // 3. NEU: Properties ermitteln
      const properties = {};
      const formData = new FormData(form);
      for (const [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          // Entfernt 'properties[' am Anfang und ']' am Ende, um den reinen Key zu erhalten
          const propKey = key.slice(11, -1);
          if (value && value.trim() !== '') {
             properties[propKey] = value;
          }
        }
      }

      // 4. AddItem aufrufen (jetzt MIT properties)
      if (window.CustomCartDrawer && typeof window.CustomCartDrawer.addItem === 'function') {
        window.CustomCartDrawer.addItem(variantId, quantity, properties);
      } else {
        console.error('Custom Cart Drawer ist nicht verfügbar. Fallback: normales Submit.');
        form.submit();
      }
    });

    // Event Delegation für Quantity, Remove, VIP
    if (this.nodes.drawerInner) {
      this.nodes.drawerInner.addEventListener('click', (event) => {
        // Guard: Mengensteuerung gesperrt?
        if (event.target.closest('.quantity__button')) {
          const row = event.target.closest('.drawer-item');
          if (row?.dataset.qtyLocked === '1') {
            event.preventDefault();
            return;
          }
        }

        // Quantity Buttons
        if (event.target.closest('.quantity__button')) {
          event.preventDefault();
          const button = event.target.closest('.quantity__button');
          const key = button.dataset.key;
          const line = parseInt(button.dataset.line, 10);
          const input = button.parentElement.querySelector('.quantity__input');
          if (!input) return;
          
          const currentQuantity = parseInt(input.value, 10) || 0;
          let newQuantity = currentQuantity;
          if (button.name === 'plus') newQuantity++;
          else if (button.name === 'minus') newQuantity = Math.max(0, currentQuantity - 1);

          if (newQuantity !== currentQuantity) {
            this.updateQuantity(key, newQuantity, line);
          }
        }

        // Remove Button
        if (event.target.closest('.drawer-item__remove')) {
          event.preventDefault();
          const button = event.target.closest('.drawer-item__remove');
          this.updateQuantity(button.dataset.key, 0, parseInt(button.dataset.line, 10));
        }

        // Add VIP Button
        if (event.target.closest('#add-vip-button') && this.nodes.vipSelector) {
          event.preventDefault();
          const variantId = this.nodes.vipSelector.value;
          if (variantId) this.addItem(variantId, 1, {}, true);
        }
      });

      // 🚀 OPTIMIERT: Debounce auf 300ms erhöht
      let debounceTimeout;
      this.nodes.drawerInner.addEventListener('change', (event) => {
        if (event.target.matches('.quantity__input')) {
          // Guard: Mengensteuerung gesperrt?
          if (event.target.closest('.drawer-item')?.dataset.qtyLocked === '1') {
            event.preventDefault();
            return;
          }

          clearTimeout(debounceTimeout);
          debounceTimeout = setTimeout(() => {
            const input = event.target;
            const key = input.dataset.key;
            const line = parseInt(input.dataset.line, 10);
            const newQuantity = Math.max(0, parseInt(input.value, 10) || 0);

            if (newQuantity !== parseInt(input.getAttribute('value'), 10)) {
              this.updateQuantity(key, newQuantity, line);
            }
          }, 300); // 150ms → 300ms
        }
      });
    }

    /*
    // Upside Hooks
    window.addEventListener('Upside::UCD::CartVisible', () => {
      this.lastFocusedElement = document.activeElement;
      this.open();
    });
    window.addEventListener('Upside::UCD::CartHidden', () => {
      setTimeout(() => {
        if (this.lastFocusedElement?.focus) this.lastFocusedElement.focus();
        this.lastFocusedElement = null;
      }, 50);
    });
    */
  }, 

  // Prüft, ob eine VIP-Variante im übergebenen Cart ist
  cartHasVip(cart) {
    const vipIds = (window.vipVariantIds || []).map(String);
    return Array.isArray(cart?.items) && cart.items.some(i => vipIds.includes(String(i.variant_id)));
  },

  // Blendet die VIP-Box(en) ein/aus – inkl. Mindestwarenkorb-Logik
setVipModuleVisibility: function(cart) {
  const wrapper =
    this.nodes.drawer?.querySelector('.drawer__footer .drawer__vip-module') ||
    document.getElementById('cart-drawer-vip-module');
  const vipBox = document.getElementById('VipBox');

  if (!wrapper || !cart) return;

  const cartItemCount = cart.item_count || 0;
  const hasVip = this.cartHasVip(cart);

  // Basis-Regel: nur zeigen, wenn Warenkorb nicht leer + noch keine VIP im Cart
  let shouldShow = !hasVip && cartItemCount > 0;

  // Mindestwarenkorb-Logik aus den data-Attributen
  const minEnabledAttr = wrapper.dataset.vipMinEnabled;
  const minEnabled = String(minEnabledAttr).toLowerCase() === 'true';
  const minValue = parseInt(wrapper.dataset.vipMinValue || '0', 10) || 0;
  const totalPrice = cart.total_price || 0;

  if (minEnabled && minValue > 0 && totalPrice < minValue) {
    shouldShow = false;
  }

  // NEU: Prüfe ob es überhaupt rabattfähige Produkte gibt
  // UND ob die VIP-Box selbst denkt, sie sollte sichtbar sein
  if (shouldShow && vipBox) {
    // Trigger die VIP-Box ihre eigene Berechnung zu machen
    const vipController = vipBox.__vipController;
    if (vipController) {
      const save = vipController.computeSavingCents(cart);
      // Nur anzeigen wenn tatsächlich Ersparnis vorhanden
      if (save <= 0) {
        shouldShow = false;
      }
    }
  }

  [wrapper, vipBox].forEach((el) => {
    if (!el) return;
    el.style.display = shouldShow ? 'block' : 'none';
    el.classList.toggle('is-hidden', !shouldShow);
  });
},

  // Success Message
  showSuccessMessage: function(timeout = 0) {
    if (!this.nodes.successMessage) return;
  
    if (this.state.itemCount > 0 && this.state.lastAction === 'added') {
      this.nodes.successMessage.style.display = 'flex';
      
      // Nur Auto-Hide wenn timeout > 0
      if (timeout > 0) {
        clearTimeout(this._successTimeout);
        this._successTimeout = setTimeout(() => {
          this.hideSuccessMessage();
        }, timeout);
      }
    } else if (this.state.itemCount === 0) {
      this.hideSuccessMessage();
    }
  },

  // Explizites Verstecken
  hideSuccessMessage: function() {
    if (this.nodes.successMessage) {
      this.nodes.successMessage.style.display = 'none';
    }
    clearTimeout(this._successTimeout);
  },

  open: function(showSuccess = false) {
    document.body.classList.add('drawer-open', 'ucd-drawer-open-right');
    if (this.nodes.drawer) {
      this.nodes.drawer.setAttribute('aria-hidden', 'false');
      const firstFocusable = this.nodes.drawer.querySelector('button:not([disabled]), a[href]');
      if (firstFocusable) setTimeout(() => firstFocusable.focus(), 50);
    }
    this.loadCart();
  },

close: function() {
  document.body.classList.remove('drawer-open', 'ucd-drawer-open-right');

  // Fokus zuerst aus dem Drawer raus
  if (this.lastFocusedElement && typeof this.lastFocusedElement.focus === 'function') {
    try {
      this.lastFocusedElement.focus();
    } catch(e) {}
    this.lastFocusedElement = null;
  } else {
    // Fallback: Fokus auf Body oder irgendwas außerhalb
    if (document.body && typeof document.body.focus === 'function') {
      document.body.focus();
    }
  }
},


/*
  close: function() {
    document.body.classList.remove('drawer-open', 'ucd-drawer-open-right');
    if (this.nodes.drawer) this.nodes.drawer.setAttribute('aria-hidden', 'true');
    
    this.hideSuccessMessage();
    
    if (this.lastFocusedElement?.focus) {
      setTimeout(() => {
        try { this.lastFocusedElement.focus(); } catch(e) {}
        this.lastFocusedElement = null;
      }, 50);
    }
  },
*/

  // 🚀 OPTIMIERT: Selective Loading
  setLoading: function(loading, selective = false) {
    this.isLoading = loading;
    
    if (this.nodes.loadingOverlay) {
      this.nodes.loadingOverlay.style.display = loading ? 'flex' : 'none';
    }
    
    // 🚀 NEU: Bei selective = true nur Content-Buttons deaktivieren
    if (this.nodes.drawerInner) {
      const selector = selective 
        ? '.drawer__content button, .drawer__content input, .drawer__content select'
        : 'button, input, select';
        
      this.nodes.drawerInner.querySelectorAll(selector).forEach(el => {
        if (!el.closest('.drawer__header') || !el.matches('.drawer__close-button')) {
          el.disabled = loading;
        }
      });
    }
  },

  // 🚀 NEU: VIP-Exklusivitäts-Prüfung
  async enforceVipExclusivity(cart) {
    const vipIds = (window.vipVariantIds || []).map(String);
    const vipItems = cart.items.filter(item => vipIds.includes(String(item.variant_id)));
    
    // Wenn mehr als 1 VIP-Produkt im Cart: Nur das neueste behalten
    if (vipItems.length > 1) {
      console.log('🔍 Found multiple VIP items:', vipItems.map(i => ({ 
        variant_id: i.variant_id, 
        key: i.key,
        index: cart.items.indexOf(i)
      })));
      
      // Das neueste VIP-Item ist das mit dem höchsten Index im cart.items Array
      let newestVip = vipItems[0];
      let highestIndex = cart.items.indexOf(vipItems[0]);
      
      vipItems.forEach(vipItem => {
        const currentIndex = cart.items.indexOf(vipItem);
        if (currentIndex > highestIndex) {
          highestIndex = currentIndex;
          newestVip = vipItem;
        }
      });
      
      console.log('✅ Keeping newest VIP:', newestVip.variant_id, 'at index', highestIndex);
      
      // Batch-Update: Alle VIPs auf 0, nur das neueste auf 1
      const updates = {};
      const newestVipVariantId = String(newestVip.variant_id);
      vipIds.forEach(id => {
        updates[id] = (id === newestVipVariantId) ? 1 : 0;
      });
      
      try {
        const response = await fetch(this.settings.routes.cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates })
        });
        
        if (response.ok) {
          return await response.json();
        }
      } catch (error) {
        console.error('Error enforcing VIP exclusivity:', error);
      }
    }
    
    return cart;
  },

  loadCart: function() {
    this.setLoading(true);

    fetch(this.settings.routes.cartUrl)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        return response.json();
      })
      .then(async cart => {
        if (typeof cart !== 'object' || cart === null || typeof cart.items === 'undefined') {
          throw new Error('Invalid cart data');
        }
        
        // VIP-Exklusivität prüfen und ggf. korrigieren
        cart = await this.enforceVipExclusivity(cart);
        
        this.renderCart(cart);
      })
      .catch(error => {
        console.error('Error loading cart:', error);
        if (this.nodes.itemsContainer) {
          this.nodes.itemsContainer.innerHTML = `<p>Fehler beim Laden des Warenkorbs.</p>`;
        }
      })
      .finally(() => this.setLoading(false));
  },

  // Nur noch Notification, kein Re-Render
  syncWithVipBox: function(cart) {
    const vipBox = document.getElementById('VipBox');
    if (!vipBox || !vipBox.__vipController) return;
    
    if (typeof vipBox.__vipController.reflectCartState === 'function') {
      vipBox.__vipController.reflectCartState(cart);
    }
  },

  // Batch-DOM-Updates & Template-Caching
  renderCart: function(cart) {
    if (!this.nodes.itemsContainer) return;

    // Verwende requestAnimationFrame für smooth rendering
    requestAnimationFrame(() => {
      this.nodes.itemsContainer.innerHTML = '';

      if (cart.item_count === 0) {
        const placeholder = this.nodes.drawer.querySelector('.drawer__items-placeholder');
        if (placeholder) {
          const clone = placeholder.content ? placeholder.content.cloneNode(true) : placeholder.cloneNode(true);
          this.nodes.itemsContainer.appendChild(clone);
        } else {
          this.nodes.itemsContainer.innerHTML = `<div class="drawer__items-placeholder"><p>Dein Warenkorb ist leer.</p></div>`;
        }
      } else {
        const itemTemplateHtml = this.templateCache.originalHtml;
        if (!itemTemplateHtml) {
          console.error("Cart item template not found!");
          return;
        }

        const fragment = document.createDocumentFragment();
        
        cart.items.forEach((item, index) => {
          if (!item) return;

          // Properties HTML mit Übersetzung UND fester Struktur
          let propertiesHtml = '';
          if (item.properties) {
            propertiesHtml = Object.entries(item.properties)
              .filter(([key]) => !key.startsWith('_'))
              .map(([key, value]) => {
                
                // 1. Übersetzung
                let displayKey = key;
                if (key === 'Recipient email') displayKey = 'E-Mail';
                if (key === 'Recipient name') displayKey = 'Empfänger';
                if (key === 'Message') displayKey = 'Nachricht';

                // 2. Struktur: Wir packen es in ein DIV, damit es IMMER eine neue Zeile ist
                return `<div class="prop-row"><strong>${displayKey}:</strong> ${value || ''}</div>`;
              })
              .join('');
          }

          const imageUrl = item.image ? item.image.replace(/(\.[^.]*)$/, '_100x$1') : '';
          const originalLinePrice = item.original_line_price || 0;
          const finalLinePrice = item.final_line_price || 0;
          const hasDiscount = originalLinePrice !== finalLinePrice && originalLinePrice > 0;

          let discountTitle = '';
          if (Array.isArray(item.discounts) && item.discounts.length > 0) {
            discountTitle = item.discounts[0].title || '';
          }

          let itemHtml = itemTemplateHtml
            .replace(/{key}/g, item.key || `item-${index}`)
            .replace(/{line}/g, index + 1)
            .replace(/{image_url}/g, imageUrl)
            .replace(/{vendor}/g, item.vendor || '')
            .replace(/{product_title}/g, item.product_title || 'Untitled')
            .replace(/{url}/g, item.url || '#')
            .replace(/{variant_title}/g, item.variant_title || '')
            .replace(/{properties}/g, propertiesHtml)
            .replace(/{quantity}/g, item.quantity || 0)
            .replace(/{original_price}/g, hasDiscount ? this.settings.formatMoney(originalLinePrice) : '')
            .replace(/{final_price}/g, this.settings.formatMoney(finalLinePrice))
            .replace(/{original_price_class}/g, hasDiscount ? 'price--original' : 'is-hidden')
            .replace(/{discount_display}/g, hasDiscount ? 'block' : 'none')
            .replace(/{discount_title}/g, discountTitle);

          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = itemHtml;

          const rootEl = tempDiv.firstElementChild;
          if (rootEl) {
            // Variant-ID in DOM legen
            rootEl.dataset.variantId = String(item.variant_id || '');
            rootEl.dataset.productId = String(item.product_id || '');

            // Mengensteuerung für definierte Varianten ausblenden
            const locked = (window.qtyLockedProductIds || []).map(String).includes(String(item.product_id));
            if (locked) {
              rootEl.dataset.qtyLocked = '1';
              const qty = rootEl.querySelector('.drawer-item__quantity');
              if (qty) {
                qty.style.display = 'none';
                qty.querySelectorAll('button, input').forEach(n => { n.disabled = true; });
              }
            }

            fragment.appendChild(rootEl);
          }
        });

        this.nodes.itemsContainer.appendChild(fragment);

        // Input values setzen
        this.nodes.itemsContainer.querySelectorAll('.quantity__input').forEach(input => {
          input.setAttribute('value', input.value);
        });
      }

      // Subtotal
      if (this.nodes.subtotal) {
        this.nodes.subtotal.textContent = this.settings.formatMoney(cart.total_price || 0);
      }

      const hasVip = this.cartHasVip(cart);

      // Shipping Notice
      if (this.nodes.shippingNotice) {
        let shippingText = '';

        if (hasVip) {
          shippingText = '<span class="shipping_notice__vip">Kostenloser VIP-Versand</span>';
        } else if (this.isVip) { 
          shippingText = '<span class="shipping_notice__vip">Kostenloser VIP-Versand</span>';
        } else if ((cart.total_price || 0) >= this.settings.freeShippingThreshold) {
          shippingText = '<span class="shipping_notice__free">versandkostenfrei</span>';
        } else {
          shippingText = `zzgl. Versandkosten (frei ab ${this.settings.formatMoney(this.settings.freeShippingThreshold)})`;
        }

        this.nodes.shippingNotice.innerHTML = shippingText;
      }

      // State aktualisieren
      this.state.itemCount = cart.item_count;
      if (cart.item_count === 0) this.state.lastAction = null;

      // 🔢 Bubble über zentrale Funktion aktualisieren
      this.updateCartBubble(cart.item_count);

      // VIP-Box Steuerung
      this.setVipModuleVisibility(cart);
      this.syncWithVipBox(cart);

      // Success-Message-Steuerung
      if (this.state.lastAction === 'added' && this.state.itemCount > 0) {
        this.showSuccessMessage();
      } else if (this.state.itemCount === 0) {
        this.hideSuccessMessage();
        this.state.lastAction = null;
      }

      // Checkout-Button
      if (this.nodes.checkoutButton) {
        this.nodes.checkoutButton.disabled = cart.item_count === 0;
      }
    });
  },

  
// addItem mit optimiertem VIP-Flow
addItem: async function(variantId, quantity = 1, properties = {}, isVipProduct = false) {
  if (this.isLoading || !variantId) return;
  this.setLoading(true, true); // Selective loading

  const previousAction = this.state.lastAction;
  const previousCount = this.state.itemCount;

  // lastAction nur bei NICHT-VIP-Produkten auf 'added' setzen
  if (!isVipProduct) {
    this.state.lastAction = 'added';
  }

  try {
    const vipIds = (window.vipVariantIds || []).map(String);
    const isVipVariant = vipIds.includes(String(variantId));

    if (isVipVariant) {
      // 🔥 Neuer Weg: Ein einziger cart/update.js-Call mit Batch-Updates
      const updates = {};
      const variantIdStr = String(variantId);

      vipIds.forEach(id => {
        // Gewählten VIP auf 1, alle anderen auf 0
        updates[id] = (id === variantIdStr) ? 1 : 0;
      });

      const response = await fetch(this.settings.routes.cartUpdateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        this.state.lastAction = previousAction;
        throw new Error(`HTTP ${response.status}`);
      }

      const finalCart = await response.json();

      // State & Bubble aus echter Server-Antwort
      this.state.itemCount = finalCart.item_count;
      this.updateCartBubble(this.state.itemCount);

      // Re-Force Bubble, um andere Scripts zu übersteuern
      setTimeout(() => {
        this.updateCartBubble(this.state.itemCount);
      }, 150);
      setTimeout(() => {
        this.updateCartBubble(this.state.itemCount);
      }, 300);

    } else {
      // 🧊 Non-VIP bleibt wie bisher: add.js → cart.js
      const response = await fetch(this.settings.routes.cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity, properties }] })
      });

      if (!response.ok) {
        this.state.lastAction = previousAction;
        throw new Error(`HTTP ${response.status}`);
      }

      await response.json();

      // Echte item_count vom Server holen
      const finalCartResponse = await fetch(this.settings.routes.cartUrl);
      const finalCart = await finalCartResponse.json();

      this.state.itemCount = finalCart.item_count;
      
      window.dispatchEvent(new CustomEvent('UpsellProductAdded', {
    detail: { variantId: variantId }
  }));

      // Bubble sofort updaten + re-enforcen
      this.updateCartBubble(this.state.itemCount);
      setTimeout(() => {
        this.updateCartBubble(this.state.itemCount);
      }, 150);
      setTimeout(() => {
        this.updateCartBubble(this.state.itemCount);
      }, 300);
    }

    if (!isVipProduct) {
      this.showSuccessMessage();
    }

    this.open();

  } catch (error) {
    console.error('Error adding item:', error);
    alert(`Fehler: ${error.message}`);
    this.state.lastAction = previousAction;
    this.state.itemCount = previousCount;
    this.updateCartBubble(previousCount);
  } finally {
    this.setLoading(false);
  }
},

  // Optimistic UI Updates
  updateQuantity: async function(key, quantity) {
  if (this.isLoading || !key) return;

  const itemElement = this.nodes.itemsContainer?.querySelector(`.drawer-item[data-key="${key}"]`);
  const buttons = itemElement?.querySelectorAll('button, input');
  buttons?.forEach(el => el.disabled = true);

  // Quantity hart validieren
  const q = Number(quantity);
  if (!Number.isFinite(q) || !Number.isInteger(q) || q < 0) {
    buttons?.forEach(el => el.disabled = false);
    console.error('Ungültige Menge', { key, quantity });
    return;
  }

  try {
    const payload = { id: String(key), quantity: q };

    const response = await fetch(this.settings.routes.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      console.error('Cart Error Detail:', { status: response.status, payload, data });
      throw new Error(data.description || data.message || `HTTP ${response.status}`);
    }

    this.renderCart(data);

  } catch (error) {
    console.error('Error updating quantity:', error);
    alert(`Fehler: ${error.message}`);
  } finally {
    buttons?.forEach(el => el.disabled = false);
  }
},

/*  
  updateVipSavings: function(cart) {
  if (!this.nodes.vipPotentialSavings || !this.nodes.vipSavingsAmount || !cart) return;

  const vipVariantIds = window.vipVariantIds || [];
  const discountableTotal = cart.items
    .filter(item => !vipVariantIds.includes(item.variant_id.toString()))
    .reduce((sum, item) => sum + (item.final_line_price || 0), 0);

  if (discountableTotal > 0) {
    const savings = Math.round(discountableTotal * this.settings.vipDiscount);
    this.nodes.vipSavingsAmount.textContent = this.settings.formatMoney(savings);
    this.nodes.vipPotentialSavings.style.display = 'list-item';
  } else {
    this.nodes.vipPotentialSavings.style.display = 'none';
  }
},
*/
};

// Initialisieren
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CustomCartDrawer.init());
} else {
  CustomCartDrawer.init();
}

window.CustomCartDrawer = CustomCartDrawer;